export var ExchangeStatusEnum;
(function (ExchangeStatusEnum) {
    ExchangeStatusEnum["DRAFT"] = "draft";
    ExchangeStatusEnum["PENDING"] = "pending";
    ExchangeStatusEnum["IN_PROGRESS"] = "in_progress";
    ExchangeStatusEnum["CONFIRMED"] = "confirmed";
    ExchangeStatusEnum["REJECTED"] = "rejected";
    ExchangeStatusEnum["UNKNOWN"] = "unknown";
})(ExchangeStatusEnum || (ExchangeStatusEnum = {}));
//# sourceMappingURL=exchange-status.enum.js.map